// Chart color utilities for theme-aware styling
export const getChartColors = () => {
  // Check if we're in dark mode using the actual theme system
  const isDarkMode = document.querySelector('.landing-page')?.classList.contains('dark-mode') || 
                     !document.querySelector('.landing-page')?.classList.contains('light-mode');
  
  return {
    text: isDarkMode ? '#ffffff' : '#1a1a1a', // White for dark, charcoal for light
    textSecondary: isDarkMode ? '#e2e8f0' : '#4a5568', // Light gray for dark, medium gray for light
    grid: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)', // Light grid for dark, dark grid for light
    legendBorder: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)', // Light border for dark, dark border for light
    background: isDarkMode ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0)', // Transparent background
  };
};

// Helper function to get theme-aware font configuration
export const getChartFont = (size = 12, weight = 'normal') => {
  const colors = getChartColors();
  return {
    family: "'TWK Everett', sans-serif",
    size,
    color: colors.text,
    weight
  };
};

// Helper function to get theme-aware title configuration
export const getChartTitle = (text, size = 24) => {
  const width = window.innerWidth;
  let responsiveSize = size;
  
  // Scale down title size based on screen width
  if (width <= 480) {
    responsiveSize = Math.min(size, 12); // Very small screens
  } else if (width <= 768) {
    responsiveSize = Math.min(size, 14); // Mobile
  } else if (width <= 1024) {
    responsiveSize = Math.min(size, 18); // Tablet
  }
  
  return {
    text: text,
    font: getChartFont(responsiveSize, 500),
    x: 0.02,
    y: 0.95,
    xanchor: 'left',
    yanchor: 'top'
  };
};

// Helper function to get theme-aware axis configuration
export const getChartAxis = (title, isXAxis = true) => {
  const colors = getChartColors();
  const baseConfig = {
    color: colors.text,
    gridcolor: colors.grid,
    font: getChartFont(12)
  };
  
  if (title) {
    baseConfig.title = {
      text: title,
      font: getChartFont(12)
    };
  }
  
  return baseConfig;
};

// Helper function to get theme-aware legend configuration
// Note: windowWidth should be passed if you want dynamic updates
export const getChartLegend = (itemCount = 1, windowWidth = window.innerWidth) => {
  const isMobile = windowWidth <= 768;
  
  if (isMobile) {
    // On mobile, use horizontal legend below chart
    // Adjust font size if there are many items
    const fontSize = itemCount > 6 ? 9 : 10;
    
    return {
      orientation: 'h',
      x: 0.5,
      y: -0.6,
      xanchor: 'center',
      yanchor: 'top',
      font: getChartFont(fontSize),
      bgcolor: 'rgba(0,0,0,0)',
      bordercolor: 'rgba(0,0,0,0)',
      borderwidth: 0,
      tracegroupgap: 8
    };
  }
  
  return {
    orientation: 'v',
    x: 1.05,
    y: 1,
    xanchor: 'left',
    yanchor: 'top',
    font: getChartFont(12),
    bgcolor: 'rgba(0,0,0,0)',
    bordercolor: 'rgba(0,0,0,0)',
    borderwidth: 0
  };
};
